import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class App extends Vue {
  public connected: boolean = true

  public get gameIsPlaying (): boolean {
    return this.$route.name === 'game'
  }

  public init () {
    const socket = (this.$feathers as any).io

    socket.on('disconnect', () => {
      this.connected = false
    })

    socket.on('connect', () => {
      this.connected = true
    })

    socket.on('reconnect', () => {
      this.$router.push({ name: 'tables' })
    })
  }

  public mounted () {
    this.init()
  }
}
